<template>
  <div class="custom-select">
    <v-subheader
      class="pa-0"
      v-if="label"
    >
      <label
        for="selection"
        class="neutral-cold-051--text text-body-3"
      >{{ label }}</label>
    </v-subheader>
    <v-select
      id="selection"
      v-bind="{ ...$attrs}"
      v-on="$listeners"
      solo
      flat
      hide-details="auto"
      item-color="primary-005"
      :menu-props="{offsetY: true, bottom: true, nudgeBottom: '4px'}"
    >
      <template v-slot:item="{ item }">
        <v-list-item-title
          class="text-body-2"
        >
          {{ item[$attrs['item-text']] }}
        </v-list-item-title>
      </template>
      <template
        v-for="(_, scopedSlotName) in $scopedSlots"
        #[scopedSlotName]="slotData"
      >
        <slot
          :name="scopedSlotName"
          v-bind="slotData"
        />
      </template>
      <template
        v-for="(_, slotName) in $slots"
        #[slotName]
      >
        <slot :name="slotName" />
      </template>

      <template slot="append-outer">
        <v-icon size="16">
          $vuetify.icons.inputErrorIcon
        </v-icon>
      </template>
    </v-select>
  </div>
</template>
<script>

export default {
  name: 'Select',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
    };
  }

};
</script>

<style lang="scss" scoped>

::v-deep.custom-select {
  .v-input__control {
    .v-input__slot {
      input {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        color: $neutral-cold-051;
        &::placeholder {
          color: $neutral-cold-051;
        }
      }
    }
    .v-select__selection--comma {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
    }
  }

  .v-select {
    .v-input__slot, .v-input__control {
      min-height: auto !important;
    }

    // Default Style
    &.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
      padding: 0 6px 0 12px ;
    }
    .v-input__control > .v-input__slot {
      background: $neutral-cold-056;
      transition: all 0.3s ease-in-out;
    }

    // Hover Style
    .v-input__control:hover > .v-input__slot {
      background: $neutral-cold-054;
    }

    // Disabled Style
    &.v-input--is-disabled .v-input__control > .v-input__slot {
      background: $neutral-cold-056;
      .v-select__selection {
        color: $neutral-043;
      }
    }
    // Readonly Style
    &.v-input--is-readonly .v-input__control > .v-input__slot{
        background: $neutral-cold-056;
        border-color: $neutral-cold-056;

        .v-select__selection {
          color: $neutral-042;
        }
        .v-icon {
          color: $neutral-043;
        }

    }
    // Error Style
    &.error--text .v-input__control > .v-input__slot {
      background: $neutral-047;

    }
    .v-messages {
      margin-top: 2px;
      margin-left: 22px;
    }
    .v-input__append-outer {
      position: absolute;
      top: 24px;
      left: 0;
      margin-left: 0;
      display: none;
    }
    &.error--text .v-input__append-outer {
      display: inline-flex;
    }

    // Focus Style
    &.v-select--is-menu-active {
      .v-input__control > .v-input__slot {
        background: $neutral-047;
        border: 1px solid $primary-001;
        box-shadow: 0px 0px 0px 2px rgba(64, 143, 255, 0.25);
      }
      &.error--text {
        .v-input__control > .v-input__slot {
          box-shadow: 0px 0px 0px 2px rgba($danger-021, 25%)
        }
      }

    }

    // Arrow icon Style
    &.v-select--is-menu-active, &.v-input--is-focused {
      & .v-input__icon--append .v-icon {
        color: $neutral-042 !important;
        caret-color: $neutral-042 !important;
      }
    }
  }
}
</style>
